// removed by extract-text-webpack-plugin
module.exports = {"date-range-picker":"date-range-picker","date-range-item":"date-range-item"};


//////////////////
// WEBPACK FOOTER
// ./src/application/component/date-range-picker/date-range-picker.style.sass
// module id = QE2y
// module chunks = 0